module.exports = __webpack_public_path__ + "media/svg/logo-sequis-001dfe8f.svg";